import styles from './VBox.module.css';

const VBox = ({
  children,
  gap,
  style,
  className,
  center,
  vcenter,
}: Readonly<{
  children: React.ReactNode;
  gap?: number | string;
  style?: React.CSSProperties;
  className?: string;
  center?: boolean;
  vcenter?: boolean;
}>) => {
  return (
    <div
      style={{
        ...(style ?? {}),
        gap,
        alignItems: center ? 'center' : undefined,
        justifyContent: vcenter ? 'center' : undefined,
      }}
      className={[styles.vbox, className].filter(Boolean).join(' ')}
    >
      {children}
    </div>
  );
};

export default VBox;
